import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

import LoadingPage from '@/common/pages/LoadingPage';
import ParticipantCard from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCard/ParticipantCard';
import ParticipantCardWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardWrapper/ParticipantCardWrapper';
import { participantsIncidentQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/participantsIncidentQueryOptions';
import { useParticipantsStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/participantsStore';
import { useEffect } from 'react';

const ImagesDamagedList = () => {
  const { id } = useParams();
  const { setCulpritStoreId } = useParticipantsStore();
  const { data, isError, isPending } = useQuery(
    participantsIncidentQueryOptions({ id: id!, view_type: 'image' }),
  );

  useEffect(() => {
    if (data?.damages[0]?.id) setCulpritStoreId(data.damages[0].id);
  }, [data, setCulpritStoreId]);

  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }

  return (
    <Box pt="1rem">
      <ParticipantCardWrapper length={data.damages.length}>
        {data.damages?.map((item, index) => (
          <ParticipantCard
            state="image"
            type="damaged"
            key={index}
            file={item}
            index={+`${index + 1}`}
            damagedType={item?.damaged_type?.const}
          />
        ))}
      </ParticipantCardWrapper>
    </Box>
  );
};
export default ImagesDamagedList;
